import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Lock } from "lucide-react";
import { toast } from "sonner";

const API_URL = process.env.REACT_APP_BACKEND_URL;

export default function DyvysAdminLoginPage() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Stocker le mot de passe admin dans le localStorage
      localStorage.setItem("dyvys_admin_password", password);
      
      // Tester si le mot de passe fonctionne
      const response = await fetch(`${API_URL}/api/dyvys/admin/series`, {
        headers: {
          "X-Admin-Password": password
        }
      });

      if (response.ok) {
        toast.success("Connexion réussie!");
        navigate("/dyvys/admin/series");
      } else {
        throw new Error("Mot de passe incorrect");
      }
    } catch (error) {
      console.error("Erreur:", error);
      toast.error("Mot de passe incorrect");
      localStorage.removeItem("dyvys_admin_password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-purple-900 to-black text-white flex items-center justify-center px-4">
      <Card className="w-full max-w-md bg-gradient-to-br from-gray-800/50 to-purple-900/30 border-purple-500/30">
        <CardHeader className="text-center">
          <div className="mx-auto w-16 h-16 bg-gradient-to-r from-purple-600 to-pink-600 rounded-full flex items-center justify-center mb-4">
            <Lock className="w-8 h-8 text-white" />
          </div>
          <CardTitle className="text-3xl text-white">DYVY'S Afrique</CardTitle>
          <CardDescription className="text-gray-400">
            Panneau d'administration
          </CardDescription>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleLogin} className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="password" className="text-white">
                Mot de passe administrateur
              </Label>
              <Input
                id="password"
                type="password"
                placeholder="Entrez votre mot de passe"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="bg-gray-900/50 border-purple-500/30 text-white"
                required
              />
            </div>

            <Button
              type="submit"
              size="lg"
              disabled={loading}
              className="w-full bg-gradient-to-r from-purple-600 to-pink-600 hover:from-purple-700 hover:to-pink-700"
            >
              {loading ? "Connexion..." : "Se connecter"}
            </Button>

            <div className="text-center">
              <Button
                type="button"
                variant="link"
                onClick={() => navigate("/dyvys")}
                className="text-purple-300 hover:text-purple-100"
              >
                Retour à l'accueil
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </div>
  );
}
